class stepsPopup extends HTMLElement {
  constructor() {
    super();

    this.body = document.body;
    this.openPopupButton = document.querySelector('[data-sponser-popup]');
    this.popupOverlay = document.querySelector('[data-step-popup-overlay]');
    this.closePopupButton = document.querySelector('[data-step-popup-close]');
    this.steps = document.querySelectorAll('[data-item]');
    this.nextButton = document.querySelector('[data-next]');
    this.prevButton = document.querySelector('[data-prev]');
    this.progressBar = document.querySelector('[data-progress]');
    this.warrantyCheckbox = document.querySelector('[data-warranty-checkbox]');
    this.submitButton = document.querySelector('[data-step-form-submit-button]');
    this.currentStepIndex = 0;

    this.openPopup = this.openPopup.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.handleOverlayClick = this.handleOverlayClick.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.updateSteps = this.updateSteps.bind(this);
    document.addEventListener('DOMContentLoaded', () => {
      this.initEventListeners();
      this.updateSteps();
      this.fileEvents();
      this.selectEvent();
      this.requiredFields();
    });
  }

  initEventListeners() {
    if (this.openPopupButton) {
      this.openPopupButton.addEventListener('click', this.openPopup);
    }
    if (this.closePopupButton) {
      this.closePopupButton.addEventListener('click', this.closePopup);
    }
    if (this.popupOverlay) {
      this.popupOverlay.addEventListener('click', this.handleOverlayClick);
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.nextStep);
    }
    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.prevStep);
    }
  }

  openPopup() {
    const warrantyInput = this.warrantyCheckbox.querySelector('[data-warranty-input]');
    const isWarrantyChecked = warrantyInput && warrantyInput.checked;

    if (isWarrantyChecked) {
      // Find the index of the step with data-item="warranty"
      this.currentStepIndex = [...this.steps].findIndex(step => step.getAttribute('data-item') === 'warranty');
    } else {
      // Reset to the first step if warranty is not checked
      this.currentStepIndex = 0;
    }

    this.popupOverlay.style.display = 'flex';
    this.popupOverlay.classList.add('popup-active');
    this.body.classList.add('overflow-lock');

    this.updateSteps(); // Ensure correct step is displayed
  }

  closePopup() {
    this.currentStepIndex = 0; // Ensure index resets on close
    this.steps.forEach((step, index) => {
      step.classList.toggle('hidden', index !== 0);
    });
    this.popupOverlay.style.display = 'none';
    this.popupOverlay.classList.remove('popup-active');
    this.nextButton.parentElement.classList.remove('hidden');
    this.body.classList.remove('overflow-lock');
  }

  handleOverlayClick(e) {
    if (e.target === this.popupOverlay) {
      this.closePopup();
    }
  }

  nextStep() {
    if (this.currentStepIndex < this.steps.length - 1) {
      this.currentStepIndex++;
      this.updateSteps();
    }
  }

  prevStep() {
    if (this.currentStepIndex > 0) {
      this.currentStepIndex--;
      this.updateSteps();
    }
  }

  updateSteps() {
    // Handle previous button visibility
    if (this.currentStepIndex > 0) {
      this.prevButton.classList.remove('hidden');
    } else {
      this.prevButton.classList.add('hidden');
    }

    let mainBody = this.querySelector('[data-content-body]');
    let warrantyInput = this.warrantyCheckbox.querySelector('[data-warranty-input]');

    this.steps.forEach((step, index) => {
      const itemValue = step.getAttribute('data-item');
      if (index === this.currentStepIndex) {
        step.classList.remove('hidden');  // Use class-based hiding instead of display
        mainBody.scrollTo({ top: 0, behavior: "smooth" });

        if (itemValue === 'warranty') {
          warrantyInput.checked = false;
          this.warrantyCheckbox.classList.remove('hidden');
          this.nextButton.classList.add('disabled');
          this.nextButton.querySelector('[data-next-text]').textContent = "Filling out the application";
        } else {
          this.nextButton.querySelector('[data-next-text]').textContent = "Next";
          this.warrantyCheckbox.classList.add('hidden');
          this.nextButton.classList.remove('disabled');
        }

        if (itemValue === 'form') {
          mainBody.classList.add('popup-content__body--inner');
          this.nextButton.parentElement.classList.add('hidden');
        }
      } else {
        step.classList.add('hidden');
      }
    });

    // Ensure warranty event listener is added only once
    if (!this.warrantyListenerAdded) {
      warrantyInput.addEventListener('change', () => {
        if (warrantyInput.checked) {
          this.nextButton.classList.remove('disabled');
        } else {
          this.nextButton.classList.add('disabled');
        }
      });
      this.warrantyListenerAdded = true; // Prevent multiple bindings
    }

    // Update progress bar
    const progressPercentage = ((this.currentStepIndex + 1) / this.steps.length) * 100;
    this.progressBar.style.width = `${progressPercentage}%`;
  }

  fileEvents() {
    const presignEndpointUrl = 'https://adro-api.lukuku.co/api/presigned-url';
    const s3DomainUrl = 'https://adro-assets.s3.amazonaws.com';
    const form = this.querySelector('[data-form]');
    const fileFields = this.querySelectorAll('[data-contact-file-field]');
    if (!form) return;
    form.addEventListener("change", this.requiredFields.bind(this));
    form.addEventListener("input", this.requiredFields.bind(this));

    fileFields.forEach((field) => {
      const fileButton = field.querySelector('[data-step-form-file-button]');
      const fileInput = field.querySelector('[data-step-form-file]');
      const fileListContainer = field.querySelector('[data-step-form-file-list]');

      if (!fileInput || !fileListContainer) return;

      let currentFiles = 0;
      let uploadedFiles = 0;
      let totalFilesToUpload = 0;
      let globalIndex = 0;
      const uploadButton = this.submitButton;

      fileButton.addEventListener('click', () => {
        fileInput.click();
      });

      fileInput.addEventListener('change', async (event) => {
        const files = Array.from(event.target.files);

        uploadedFiles = 0;
        totalFilesToUpload = files.length;

        if (currentFiles + files.length > 5) {
          alert('You can only upload a maximum of 5 files.');
          return;
        }

        updateUploadButtonState(true);

        for (const file of files) {
          if (file.size > 10 * 1024 * 1024) {
            alert(`${file.name} exceeds the 10MB size limit.`);
            continue;
          }

          const fileItem = document.createElement('div');
          fileItem.className = 'file-item';
          fileItem.style.display = 'none';
          fileItem.innerHTML = `
            <span>${file.name} 
                <span class="file-size">${(file.size / 1024 / 1024).toFixed(2)}</span> 
                <span class="file-size-unit">MB</span>
            </span>
            <button class="file-remove-btn" data-file-remove-btn>X</button>`;
          fileListContainer.appendChild(fileItem);

          const removeBtn = fileItem.querySelector('[data-file-remove-btn]');
          removeBtn.addEventListener('click', () => {
            const fileInput = removeBtn.closest('[data-contact-file-field]').querySelector('[data-step-form-file]');
            if (fileInput) {
              fileInput.value = '';
            }
            this.requiredFields();
            fileItem.remove();
            currentFiles--;
            updateUploadButtonState();
          });

          try {
            const response = await fetch(presignEndpointUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ name: file.name }),
            });

            if (!response.ok) throw new Error('Failed to get presigned URL');
            const { uploadUrl, uploadPath } = await response.json();

            const uploadResponse = await fetch(uploadUrl, {
              method: 'PUT',
              body: file,
              headers: {
                'Content-Type': file.type,
              },
            });

            if (uploadResponse.ok) {
              const fileUrl = `${s3DomainUrl}/${uploadPath}`;
              const fileAttrValue = fileInput.getAttribute('data-step-form-file') || 'upload_file';
              const fileIndex = `${globalIndex}-${file.name}`;
              const hiddenInput = document.createElement('input');
              hiddenInput.type = 'hidden';
              hiddenInput.name = `contact[${fileAttrValue}_${globalIndex + 1}]`;
              hiddenInput.value = fileUrl;
              hiddenInput.dataset.fileIndex = fileIndex;
              fileItem.dataset.index = fileIndex;
              form.appendChild(hiddenInput);

              fileItem.style.display = 'flex';
              const uploadedInfo = document.createElement('span');
              uploadedInfo.textContent = ' - Uploaded';
              fileItem.querySelector('span').appendChild(uploadedInfo);

              currentFiles++;
              uploadedFiles++;
              globalIndex++;
            } else {
              console.error('Failed to upload the file:', file.name);
              fileItem.querySelector('span').textContent = `${file.name} (Upload Failed)`;
            }
          } catch (error) {
            console.error('Error uploading the file:', file.name, error);
            fileItem.querySelector('span').textContent = `${file.name} (Upload Failed)`;
          } finally {
            if (uploadedFiles === totalFilesToUpload) {
              updateUploadButtonState(false);
            }
          }
        }
      });

      function updateUploadButtonState(isUploading = false) {
        if (isUploading) {
          uploadButton.classList.add('contact__button-uploading');
        } else {
          uploadButton.classList.remove('contact__button-uploading');
        }
      }
    });
  }

  selectEvent() {
    const selects = document.querySelectorAll("[data-filter-select]");

    selects.forEach(select => {
      // Toggle dropdown on click
      select.addEventListener("click", (e) => {
        const isOpen = select.classList.contains("open");
        selects.forEach(s => s.classList.remove("open"));
        if (!isOpen) {
          select.classList.add("open");
        }
      });

      // Close dropdown when clicking an option
      select.querySelectorAll("option").forEach(option => {
        option.addEventListener("click", (e) => {
          select.classList.remove("open");
        });
      });
    });

    // Close all dropdowns when clicking outside
    document.addEventListener("click", () => {
      selects.forEach(select => {
        select.classList.remove("open");
      });
    });
  }

  requiredFields() {
    const form = this.querySelector('[data-form]');
    if (!form) return;
    const checkboxes = form.querySelectorAll('[data-checkbox]:checked');
    var confirmbox = form.querySelector('[data-contact-form-confirm]');
    const requiredFields = form.querySelectorAll('[required]');
    let allFilled = true;

    requiredFields.forEach(field => {
      if (field.type === 'file') {
        if (field.files.length === 0) {
          allFilled = false;
        }
      } else if (!field.value.trim() && !field.selectedIndex) {
        allFilled = false;
      }
    });
    if (checkboxes.length === 0) {
      allFilled = false;
    }

    if (!confirmbox.checked) {
      allFilled = false;
    }

    if (!allFilled) {
      this.submitButton.classList.add('disabled');
    } else {
      this.submitButton.classList.remove('disabled');
    }
  }
}

customElements.define('steps-popup', stepsPopup);

document.addEventListener('DOMContentLoaded', () => {
  new stepsPopup();
});
